import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from './config';

export type LastPosition = { surah: number; ayah: number };

/**
 * Where a student last reached, written by the server when the turn moves
 * away from them or their session closes.
 *
 * Read-only here by design: the rules refuse every client write, because a
 * student who could set their own would make the record worthless to the
 * معلم who relies on it to know where to resume.
 *
 * Live, because a معلم may be looking at the queue while a colleague in
 * another session finishes with the same student.
 */
export function useLastPosition(uid: string | null): LastPosition | null {
  const [position, setPosition] = useState<LastPosition | null>(null);
  useEffect(() => {
    setPosition(null);
    if (!uid) return;
    return onSnapshot(
      doc(db, 'progress', uid),
      (snap) => {
        const d = snap.data();
        const surah = d?.surah;
        const ayah = d?.ayah;
        setPosition(
          typeof surah === 'number' && typeof ayah === 'number' ? { surah, ayah } : null
        );
      },
      // A student with no record yet is the ordinary case, and a permission
      // problem must read the same way: nothing to show, not a broken screen.
      () => setPosition(null)
    );
  }, [uid]);
  return position;
}
